
import {
    ApplicationRef,
    ComponentRef,
    EmbeddedViewRef,
    Injectable,
    createComponent,
    inject
} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class DomService {
    private readonly applicationRef = inject(ApplicationRef);

    appendComponentToBody(component: any) {
        const componentRef = createComponent(component, {
            environmentInjector: this.applicationRef.injector
        });

        this.applicationRef.attachView(componentRef.hostView);

        const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);

        return componentRef;
    }

    removeComponentFromBody(componentRef: ComponentRef<any>) {
        this.applicationRef.detachView(componentRef.hostView);
        componentRef.destroy();
    }
}
